var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinsColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232 104.4",
    style: {
      enableBackground: "new 0 0 232 104.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#585897;}\n\t.st1{fill:#44BFE2;}\n\t.st2{fill:#595997;}\n\t.st3{fill:#4E74AC;}\n\t.st4{fill:#2F4489;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.8,46.9c-3.2,0-5.8,2.6-5.8,5.8c0,2.9,2.1,5.3,4.9,5.7l0,0c4.8,1.5,8.3,3.4,8.3,7.4 c0,3.9-3.5,8.2-12.1,8.2c-6.4,0-11.8-2.3-16-5.5c-0.8-0.6-1.9-0.9-2.9-0.9c-2.7,0-5.2,2.4-5.2,5.2c0,1.1,0.4,2.1,1.1,3 c4.1,4.8,13.6,7.8,22.6,7.8c16.5,0,23.6-8.7,23.6-18.9c0-10.1-7-14.3-14.7-16.9C199.2,47.8,196.8,46.9,195.8,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9,20.7c-13.4,0-22.2,7.8-22.2,17.9c0,14.7,15.1,16.4,25.6,19.4c0.3,0.1,0.6,0.2,1,0.3 c-2.4-0.7-4.2-2.9-4.2-5.6c0-3.2,2.6-5.8,5.8-5.8c0.1,0,0.3,0,0.5,0c-8.8-2.4-17.5-3.5-17.5-9.1c0-4.5,3.9-7.5,10.1-7.5 c4.9,0,10,1.3,14.3,4.1c0.9,0.6,1.9,0.9,2.9,0.9c2.6,0,5.3-2.2,5.3-5c0-1-0.4-2.1-1.1-2.9C206.3,23,197.2,20.7,189.9,20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.8,46.9c-3.2,0-5.8,2.6-5.8,5.8c0,2.6,1.8,4.9,4.2,5.6c0.4,0.1,0.8,0.1,1.1,0.1c3.2,0,5.8-2.6,5.8-5.8 c0-2.6-1.7-4.7-4-5.5l0,0c-0.2-0.1-0.5-0.1-0.7-0.2C196.1,46.9,196,46.9,195.8,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.3,27.6v49.1c0-3.1,2.5-5.6,5.6-5.6h5.6V33.2h-5.6C20.8,33.2,18.3,30.8,18.3,27.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.8,57.8c-3.1,0-5.6-2.5-5.6-5.7l0,0c0,11-7.2,18.9-17.2,18.9H29.6v5.6c0,3.1-2.5,5.6-5.6,5.6h22.2h0.1 c16.1-0.1,28.2-13.1,28.2-30.2C74.5,55.3,72,57.8,68.8,57.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.6,76.7v-5.6h-5.6c-3.1,0-5.6,2.5-5.6,5.6c0,3.1,2.5,5.6,5.6,5.6S29.6,79.8,29.6,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,22L46.2,22l-21.5,0c2.7,0.4,4.8,2.7,4.8,5.6v5.6H46c10,0,17.2,8,17.2,18.9l0,0c0-3.1,2.5-5.6,5.6-5.6 s5.6,2.5,5.6,5.6C74.5,35,62.4,22.1,46.2,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.9,33.2h5.6v-5.6c0-2.8-2.1-5.2-4.8-5.6h-0.9c-3.1,0-5.6,2.5-5.6,5.6S20.8,33.2,23.9,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.5,52.2c0-3.1-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6c0,3.1,2.5,5.7,5.6,5.7C72,57.8,74.5,55.3,74.5,52.2 L74.5,52.2L74.5,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.4,61.4L115.7,24c-2-2.4-5.6-2.7-8-0.6c-2.4,2-2.7,5.6-0.6,8l41.6,49c-0.8-1-1.3-2.2-1.3-3.6L147.4,61.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.1,22c-3.1,0-5.6,2.5-5.6,5.6v33.7l10,11.7c0.9,1.1,1.4,2.5,1.3,3.8c0-0.1,0-0.1,0-0.2V27.7 C158.7,24.5,156.2,22,153.1,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,53.2c-3.1,0-5.6,2.5-5.6,5.6v17.8c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6V58.8 C118.4,55.7,115.8,53.2,112.7,53.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.7,80.1c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-1.3-0.4-2.7-1.3-3.8l-10-11.7v15.4c0,1.4,0.5,2.6,1.3,3.6l0,0l0.1,0.1 c0.1,0.1,0.2,0.2,0.3,0.4c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1 c0.1,0,0.3,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0.2,0,0.4,0.1,0.5,0.1l0,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.5,0c0,0,0.1,0,0.2,0 c0.1,0,0.2,0,0.4-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2-0.1 c0.1,0,0.2-0.1,0.3-0.2c0,0,0.1,0,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2 c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2s0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.2-0.2 C157.5,80.2,157.6,80.1,157.7,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.6,22c-3.1,0-5.6,2.5-5.6,5.6v48.9c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6V27.6C95.2,24.5,92.7,22,89.6,22"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 195.3,
    cy: 52.6,
    rx: 5.8,
    ry: 5.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinsColor);
export default __webpack_public_path__ + "static/media/Dins_color.6032faf7226a1664f3dcb9321216489c.svg";
export { ForwardRef as ReactComponent };